import { RoutesGroup } from 'src/types/interfaces/routes-group';
//TODO: Add routes for site context
export const getRoutes = (): RoutesGroup[] => [];
